import React from 'react';
import Image from 'next/image';
import digitialimg from "../../public/images/digitial1.jpg";
import digitalsvg from "../../public/svg/digitial.svg";
import digital1svg from "../../public/svg/digitial1.svg";
 
const AboutusDigitial = () => {
   return (
      <>
         <div className='2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5 lg:my-16 my-10'>
            <div className='grid grid-cols-1 lg:grid-cols-2'>
               <div>
                  <div>
                     <h4 className='text-[#41b8ea] mb-1 lg:text-2xl text-xl font-light'>A LEADING CAMPUS DRIVE SOLUTION PAN INDIA</h4>
                     <h2 className='font-bold lg:text-[40px] text-[30px]'>Simplifying Campus Hiring for You</h2>
                     <p className='py-1 lg:text-[28px] text-[20px] lg:leading-[38px] tracking-wide'>Is campus hiring processes still bothering you? Do you want to run results-driven process for your organizations? If yes, that means you are at right place & you have found exactly the right solution.</p>
                  </div>
                  <div className='flex items-center w-full'>
                     <div>
                        <Image src={digitalsvg} alt='virtual campus hiring' className='w-12 h-12' />
                     </div>
                     <div>
                        <h3 className='font-[400] lg:text-4xl text-2xl'>Stakeholder's <span className='text-[#41b8ea] font-extrabold'>Satisfaction</span></h3>
                     </div>
                  </div>
                  <div className='ml-12'>
                     <p className='py-1 lg:text-[25px] text-[18px] lg:leading-[36px] tracking-wide'>Our campus drive solution stands out for its unmatched quality, unified process, and agile technology. Here are some reasons why our service is so highly regarded:</p>
                     <p className='pb-3 pt-2 text-[18px] leading-[25px]'><span className='font-semibold'>Unique Features:</span> Our platform offers exclusive features designed to enhance the hiring experience.</p>
                     <p className='pb-3 text-[18px] leading-[25px]'><span className='font-semibold'>Proactive Multi-Channel Support:</span> We provide extensive support across various channels, ensuring a smooth process.</p>
                     <p className='text-[18px] leading-[25px]'><span className='font-semibold'>Stakeholder Satisfaction:</span> We prioritize the satisfaction of all stakeholders involved, ensuring a seamless experience for everyone.</p>
                  </div>
               </div>
               <div className='lg:-mb-10 mt-6'>
                  <Image src={digitialimg} alt='virtual campus interview' className='w-full h-auto' />
               </div>
            </div>
            <div className='flex items-center'>
               <Image src={digital1svg} alt='campus hiring automation' className='w-12 h-12'/>
               <h3 className='font-[400] lg:text-4xl text-2xl'>Unmatched <span className='text-[#41b8ea] font-extrabold'>Expertise</span></h3>
            </div>
            <div className='ml-12'>
               <p className='py-1 lg:text-[25px] text-[18px] lg:leading-[36px] tracking-wide'>Our team comprises both technical and non-technical experts with in-depth functional experience. We understand the intricacies of the entire process and possess the technical expertise to deliver robust and scalable solutions. We take into account various factors such as requirements, functionality, and budget to provide tailored solutions for your organization.</p>
            </div>
         </div>
      </>
   )
}
 
export default AboutusDigitial